<template>
  <button
    type="button"
    v-bind="$attrs"
    v-on="$listeners"
    :class="{'disabled' : isLoading }"
    class="btn btn-primary"
  >
    <template v-if="isLoading">
      <i class="fa fa-spinner fa-spin fa-fw" />
    </template> {{ title }}
  </button>
</template>

<script>
export default {
  inheritAttrs: false,
  name: 'ButtonAsyncLoading',
  props: {
    title: {
      type: String,
      default: 'Save changes'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
